var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.hasError)?_vm._t("error",[_vm._v("ERROR")]):(_vm.isLoading)?_vm._t("loading",[_vm._v(_vm._s(_vm.prefix))]):_vm._t("success",[_vm._v(_vm._s(_vm.contributor.displayName))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }